import { axios } from "@/lib/axios";
import {
  IAPIGetCommunicationSMS,
  IAPIGetOpenConversation,
  IAPIPatchPublishCommunicationSMS,
  IAPIPatchPublishOpenConversation,
  IAPIPatchUpdateCommunicationSMS,
  IAPIPatchUpdateOpenConversation,
  IAPIPostCommunicationSMS,
  IAPIPostOpenConversation,
  TGender,
} from "../../types";

export const getCommunicationSMS = ({
  limit,
  page,
}: {
  limit?: number;
  page?: number;
} = {}): Promise<IAPIGetCommunicationSMS> => {
  return axios.get(`/notif-s/bo/api/v1/notifications`, {
    params: {
      limit,
      page,
    },
  });
};

export const createCommunicationSMS = ({
  term,
  audience,
  subject,
  message,
}: {
  audience: "ALL" | TGender | "ONE";
  subject: string;
  message: string;
  term?: string;
}): Promise<IAPIPostCommunicationSMS> => {
  const payload: { [key: string]: any } = {
    audience,
    subject,
    message,
  };

  if (term) {
    payload.term = term;
  }

  return axios.post(`/notif-s/bo/api/v1/notifications/add-message`, payload);
};

export const editCommunicationSMS = ({
  communicationSMSId,
  audience,
  subject,
  message,
  ID,
}: {
  communicationSMSId: string;
  audience: "ALL" | TGender | "ONE";
  subject: string;
  message: string;
  ID?: string;
}): Promise<IAPIPatchUpdateCommunicationSMS> => {
  return axios.patch(
    `/notif-s/bo/api/v1/notifications/${communicationSMSId}/update-message`,
    {
      audience,
      subject,
      message,
      term: ID,
    }
  );
};

export const publishCommunicationSMS = (
  communicationSMSId: string
): Promise<IAPIPatchPublishCommunicationSMS> => {
  return axios.patch(
    `/notif-s/bo/api/v1/notifications/${communicationSMSId}/send-message`
  );
};

export const deleteCommunicationSMS = (
  communicationSMSId: string
): Promise<{
  code: string;
  message: string;
}> => {
  return axios.delete(`/notif-s/bo/api/v1/notifications/${communicationSMSId}`);
};

// Open conversations

export const getOpenConversation = ({
  limit,
  page,
}: {
  limit?: number;
  page?: number;
} = {}): Promise<IAPIGetOpenConversation> => {
  return axios.get(`/chat-s/bo/api/v1/messages/global`, {
    params: {
      limit,
      page,
    },
  });
};

export const createOpenConversation = ({
  term,
  // audience,
  body,
}: {
  audience: "ALL" | TGender | "ONE";
  body: string;
  term?: string;
}): Promise<IAPIPostOpenConversation> => {
  const payload: { [key: string]: any } = {
    body,
  };

  if (term) {
    payload.term = term;
  }

  return axios.post(`/chat-s/bo/api/v1/messages/global`, payload);
};

export const editOpenConversation = ({
  openConversationId,
  audience,
  body,
  ID,
}: {
  openConversationId: string;
  audience: "ALL" | TGender | "ONE";
  body: string;
  ID?: string;
}): Promise<IAPIPatchUpdateOpenConversation> => {
  return axios.patch(
    `/notif-s/bo/api/v1/open-conversations/${openConversationId}/update-message`,
    {
      audience,
      body,
      term: ID,
    }
  );
};

export const publishOpenConversation = (
  openConversationId: string
): Promise<IAPIPatchPublishOpenConversation> => {
  return axios.patch(
    `/notif-s/bo/api/v1/open-conversations/${openConversationId}/send-message`
  );
};

export const deleteOpenConversation = (
  openConversationId: string
): Promise<{
  code: string;
  message: string;
}> => {
  return axios.delete(
    `/chat-s/bo/api/v1/messages/global/${openConversationId}`
  );
};
